import { Col, Row, Text, Title } from 'ui';
import { RemoveAccountForm } from './remove-account-form';

type P = {
  logOut: () => void;
};

// TODO: this should be in account/settings after we got merged https://gitlab.touch4it.com/pba/web/-/merge_requests/3109
const RemoveAccount = ({ logOut }: P) => (
  <Row gutter={[0, 'ms']}>
    <Col span={24}>
      <Title level={3}>Remove account</Title>
    </Col>
    <Col span={24}>
      <Text>
        Removing this account will delete all of its messages, contacts, and other data from the platform. This can’t be
        undone.
      </Text>
    </Col>
    <Col span={24}>
      <RemoveAccountForm logOut={logOut} />
    </Col>
  </Row>
);

export default RemoveAccount;
